import React, {Fragment, useCallback, useEffect, useState} from 'react';
import { useSettings } from '@common/core/settings/use-settings';
import { useTrans } from '@common/i18n/use-trans';
import { SubRateSheetAnalysisItem, SubRateSheetItem } from './sub-rate-sheet-item';
import { RowSheet } from './rate-sheet-row';
import { ParentRowSheet } from './rate-sheet-row-parent';
import { apiClient } from '@common/http/query-client';

export function SubRateSheetMeta({id, timeChange, market_rate_date, onAddSubItems, pidx, item, removeParent, loan_program_types}: {id: number, timeChange: any, market_rate_date: string, onAddSubItems: any, pidx: number, item: any, removeParent: any, loan_program_types: any}) {
  const {trans} = useTrans();

  const [subItems, setSubItems] = useState<SubRateSheetAnalysisItem[]>(item.subItems? item.subItems : [{key: "1", loan_program_type: "", investor_code: "", anaylysis_prompt: "", description: ""}]);
  const len = item.subItems ? item.subItems.length : 1;

  const [uploadedFileItems, setUploadedFileItems] = useState([]);
  
  const [cnt, setCnt] = useState(len);
  const [last, setLast] = useState(len);

  useEffect(() => {
    setSubItems(subItems);
    setLast(last+1);
  }, [cnt]);

  useEffect(() => {
    setSubItems(item.subItems);
  }, [item]);

  useEffect(() => {
    if (subItems) {
      setSubItems(subItems);
    }
  }, [subItems]);

  // const {market_rate} = useSettings();
  //const investor_codes = market_rate?.investor_codes ? JSON.parse(market_rate.investor_codes):[];
  // const loan_program_types = market_rate?.loan_program_types ? JSON.parse(market_rate.loan_program_types):[];

  const [loanProgramType, setLoanProgramType] = useState('');
  const changeLoanProgramType = (loanProgramType: string) => {
    setLoanProgramType(loanProgramType);
  }

  const [description, setDescription] = useState(subItems[0]?.description);
  const changeDescription = (description: string) => {
    setDescription(description);
  }

  const [analysisPrompt, setAnalysisPrompt] = useState(subItems[0]?.analysis_prompt);
  const changeAnalysisPrompt = (analysisPrompt: string) => {
    setAnalysisPrompt(analysisPrompt);
  }

  const fetchSheetName =  useCallback(async (id: number, investor_code: string, loan_program_type: string) => {
    return await apiClient.get(`market-rates/${id}/sheet-names`, {params: {investor_code: investor_code, loan_program_type: loan_program_type}});
  }, []);

  const fetchInvestorCode =  useCallback(async (id: number, loan_program_type: string) => {
    return await apiClient.get(`market-rates/${id}/investor-codes`, {params: {loan_program_type: loan_program_type}});
  }, []);

  // const fetchLoanProgramType =  useCallback(async (id: number) => {
  //   return await apiClient.get(`market-rates/${id}/loan-program-types`);
  // }, []);

  return (
    <>
      <div className='gap-10 flex w-[100%]'>
        <div className='w-[100%]'>
          
          <div className='gap-10'>
            <div className='flex'>
              <div className='w-[90%] mt-20'>
              </div>
              
            </div>
            <div className='w-[100%] flex gap-10'>
              <div className="w-full table-wrp block flex flex-col overflow-y-scroll">
                <table className="w-[100%] table">
                  <tbody className="h-30 overflow-y-auto">
                  {subItems?.map((subItem: SubRateSheetItem, index: number) => (
                  <>
                    {index == 0 ? (
                      <>
                      <ParentRowSheet key={`fist-row-${pidx}-${index}-${id}`} id={id} pidx={pidx} index={index} item={item} subItem={subItem} subItems={subItems} onAddSubItems={onAddSubItems} cnt={cnt} setCnt={setCnt} removeParent={removeParent} last={last} changeLoanProgramType={changeLoanProgramType}  changeDescription={changeDescription} changeAnalysisPrompt={changeAnalysisPrompt} loan_program_types={loan_program_types} />
                      <RowSheet key={`row-${pidx}-${index}-${id}`} id={id} market_rate_date={market_rate_date} loan_program_type={loanProgramType} analysis_prompt={analysisPrompt} description={description} item={item} subItem={subItem} pidx={pidx} index={index} subItems={subItems} onAddSubItems={onAddSubItems} setCnt={setCnt} cnt={cnt} fetchInvestorCode={fetchInvestorCode} fetchSheetName={fetchSheetName}/>
                      </>
                    ):(
                      <RowSheet key={`row-${pidx}-${index}-${id}`} id={id} market_rate_date={market_rate_date} loan_program_type={loanProgramType} analysis_prompt={analysisPrompt} description={description} item={item} subItem={subItem} pidx={pidx} index={index} subItems={subItems} onAddSubItems={onAddSubItems} setCnt={setCnt} cnt={cnt} fetchInvestorCode={fetchInvestorCode} fetchSheetName={fetchSheetName}/>
                    )}
                  </>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
    
      </div>
    </>
  );
}